import { useState } from 'react'
import DataTable from './DataTable'
import IsNowLoading from '../../../Shared/IsNowLoading'
import ProjectPageHeading from '../../../Shared/ProjectPageHeading'

function EmailHistories(props){
    const [isNowLoading] = useState(false)
    const [error, setError] = useState(false)

    return (
        <IsNowLoading isNowLoading={isNowLoading} error={error} setError={setError}>
            <ProjectPageHeading pageTitle='Email Histories'>
                <div>
                    <DataTable projectPermissions={props.projectPermissions} project={props.project}/>
                </div>
            </ProjectPageHeading>
        </IsNowLoading>
    )
}

export default EmailHistories